<p>encounter-billing works!</p>
<p>{{encounterId}}</p>
